import { useCallback } from 'react';
import { collectionsRoute } from '../routes';
import { useNavigateWithSearchParams } from './useNavigateWithSearchParams';

export const useCollectionsCancelNavigation = () => {
    const navigate = useNavigateWithSearchParams();

    const handlerClick = useCallback(() => {
        navigate(collectionsRoute.getUrl());
    }, [navigate]);

    return { handlerClick };
};
